interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'sm' | 'md' | 'lg';
}

const paddingMap = {
  sm: 'p-5',
  md: 'p-8',
  lg: 'p-10',
};

export default function Card({
  children,
  className = '',
  padding = 'md',
}: CardProps) {
  return (
    <div
      className={[
        'bg-white rounded-lg border border-stone-mid',
        'shadow-[0_1px_2px_rgba(31,41,55,0.04),0_8px_24px_rgba(31,41,55,0.06)]',
        paddingMap[padding],
        className,
      ].join(' ')}
    >
      {children}
    </div>
  );
}
